module.exports = __webpack_public_path__ + "static/media/calendar-2.a446a6d0.svg";